import { connect } from 'react-redux';
import { selectors as notificationsSelectors } from 'modules/api/notifications/currentModule';
import Status from './Status';

const mapStateToProps = (state) => ({
	newestNotifications: notificationsSelectors.newestPerAsset(state),
});

export default connect(mapStateToProps)(Status);
